<template>
    <div class="dsCulture">
        <div class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item  :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item >大圣文化</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- 标题 -->
            <h3 class="font-style-s">
                <img src="@/assets/imgs/yy/3@2x.png" alt="">
                大圣文化
                <img src="@/assets/imgs/yy/4@2x.png" alt="">
            </h3>
            <!-- tab -->
            <div class="banner-title">
                <div v-for="(val,i) in meanLists"
                     :key="i"
                     :class="tabActive === val.id && 'active'"
                     @click="handleClickTab(val)">{{val.name}}</div>
            </div>
            <!-- 内容 -->
            <ul>
                <li v-for="item in lists" :key="item.id" @click="handleDetail(item)">
                    <img class="list-img" :src="item.picUrl" alt="">
                    <div class="texts">
                        <h5>{{item.title}}</h5>
                        <div class="date-time">
                            <label for="">
                                {{item.year}}年{{item.month}}月{{item.day}}日
                            </label>
                            <span class="author">{{item.author}}</span>
                        </div>
                        <p class="line-clamp3">{{item.introduction || '暂无描述~'}}</p>
                        <img class="more"  src="@/assets/imgs/more@3x.png" alt="">
                    </div>
                </li>
            </ul>
            <div class="fs12" v-if="!lists.length">暂无数据</div>
            <el-pagination
                background
                class="pagination"
                layout="prev, pager, next"
                @current-change="handlePageChange"
                :current-page="page"
                :total="total"
                :page-size="10">
            </el-pagination>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { articleLists } from '@/api/index';
import moment from 'moment';
import { useRouter, useRoute } from 'vue-router/composables';
const router = useRouter();
const route = useRoute();

const lists = ref([]);
const page = ref(1);
const meanLists = ref([
    {
        name: '大圣传说',
        id: 8
    },
    {
        name: '学术研究',
        id: 9
    },
    {
        name: '文化交流',
        id: 10
    },
    {
        name: '大圣文选',
        id: 11
    }
]);
const categoryId = ref(8);
const tabActive = ref(8);
onMounted(() => {
    tabActive.value = parseInt(route.query.id) || 8;
    categoryId.value = parseInt(route.query.id) || 8;
    getZxLists();
});
const handleClickTab = (val) => {
    tabActive.value = val.id;
    categoryId.value = val.id;
    page.value = 1;
    getZxLists();
};
// 获取资讯列表
const getZxLists = () => {
    articleLists({
        pageNo: page.value,
        pageSize: 10,
        categoryId: categoryId.value
    }).then(({ data }) => {
        const _data = data?.list || [];

        _data.forEach((element) => {
            element.year = moment(element.createTime).format('YYYY');
            element.month = moment(element.createTime).format('MM');
            element.day = moment(element.createTime).format('DD');
        });

        lists.value = _data;
        total.value = data?.total || 0;
    });
};

const handleDetail = (item) => {
    if (item.wechatUrl) {
        window.open(item.wechatUrl, '_blank');
    } else {
        router.push('/literatureLecture/detail?id=' + item.id + '&categoryId=' + 4);

    }
};


const total = ref(0);
const handlePageChange = (val) => {
    page.value = val;
    getZxLists();
};
</script>

<style lang="scss" scoped>
.container{
    padding: 30px 0;

   h3{
        font-weight:700;
        color:#555555;
        font-size:33px;
        text-align:center;
        margin-bottom: 22px;
        margin-top: 18px;
        img{
            width: 24px;
            height: 37px;
            vertical-align: middle;
        }
    }
    .banner-title{
        margin-top: 44px;
        margin-bottom: 100px;
        display: flex;
        gap:32px;
        justify-content: center;
        > div{
            width: 220px;
            height: 56px;
            color:#4e4e4e;
            font-size:14px;
            background: url('~@/assets/imgs/unchecked.png') no-repeat;
            background-size: contain;
            text-align: center;
            line-height: 56px;
            cursor: pointer;
        }
        .active{
            background: url('~@/assets/imgs/checked@3x.png') no-repeat;
            background-size: contain;
            color: #fff;
        }
    }
    ul{
        li{
            display: flex;
            background: #fff;
            padding: 15px 18px;
            margin-bottom: 20px;
            cursor: pointer;

            .list-img{
                width: 191px;
                height: 261px;
                object-fit: cover;
            }
            .texts{
                padding:17px 32px;
                flex: 1;
                box-sizing: border-box;
                 position: relative;
                 .date-time{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 10px;
                    .author{
                        color:#848484;
                        font-size:18px;
                    }
                 }
                h5{
                    color:#232323;
                    font-size:24px;
                    margin-bottom: 20px;
                }
                label{
                    color:#848484;
                    font-size:18px;
                    display: block;
                    border-bottom: 1px dotted rgba(#707070,0.4);
                }
                p{
                    color:#848484;
                    font-size:18px;
                    margin-top: 15px;
                }
                a{
                    width: 87px;
                    height: 26px;
                    border: 1px solid;
                    border-color: #686868;
                    font-size: 14px;
                    position: absolute;
                    bottom: 10px;
                    text-align: center;
                    line-height: 26px;
                    color: #686868;
                }
                .more{
                      width: 87px;
                    height: 26px;
                    font-size: 14px;
                    position: absolute;
                    bottom: 10px;
                    text-align: center;
                    line-height: 26px;
                    color: #686868;
                }
            }
        }
    }

    .pagination{
        margin: 100px auto;
        text-align: center;
    }
}
</style>
